import { useState, useEffect } from 'react'
import { Table, Button } from 'react-bootstrap'
import { FaTrash, FaRegEdit } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { useParams } from '../../../Providers/ParamsProvider'
import LoadingSpinner from '../../../Components/Components/LoadingSpinner'
import AddEditFooterItemModal from '../Modals/AddEditFooterItemModal'
import AddEditFooterHeaderModal from '../Modals/AddEditFooterHeaderModal'
import useConfirmDelete from '../../../Hooks/useConfirmDelete'

const AdminPanelFooter = () => {
    const { handleGetFooterElements, handleDeleteFooterItem, handleDeleteFooterHeader } = useParams()
    const { requestDelete, confirmModal } = useConfirmDelete()
    const [headers, setHeaders] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [itemModal, setItemModal] = useState({ show: false, editItem: null })
    const [headerModal, setHeaderModal] = useState({ show: false, isRegistrationProfit: false, editItem: null })

    useEffect(() => {
        const fetchFooterElements = async () => {
            setIsLoading(true)
            const items = await handleGetFooterElements()
            setHeaders(items)
            setIsLoading(false)
        }

        fetchFooterElements()
    }, [])

    const refreshFooterElements = async () => {
        const items = await handleGetFooterElements(true) //wymuszamy pobranie z API, by zaciągnąć aktualny stan (np. nowe Id)
        setHeaders(items)
    }

    const footerHeaders = headers.filter(h => !h.isRegistrationProfit)
    const registrationHeaders = headers.filter(h => h.isRegistrationProfit)

    const handleEditHeader = (header) => {
        setHeaderModal({ show: true, isRegistrationProfit: header.isRegistrationProfit, editItem: header })
    }

    const handleEditItem = (item) => {
        setItemModal({ show: true, editItem: item })
    }

    const handleDeleteItem = async (itemId) => {
        const success = await handleDeleteFooterItem(itemId)
        if (success) {
            toast.success('Usunięto pozycję.')
            refreshFooterElements()
        } else {
            toast.error('Błąd podczas usuwania pozycji!')
        }
    }

    const handleDeleteHeader = async (headerId) => {
        const success = await handleDeleteFooterHeader(headerId)
        if (success) {
            toast.success('Usunięto nagłówek.')
            refreshFooterElements()
        } else {
            toast.error('Błąd podczas usuwania nagłówka!')
        }
    }

    const requestDeleteHeader = (header) => {
        const hasItems = (header.footerItems?.length ?? 0) > 0
        const message = hasItems
            ? 'Nagłowek zawiera pozycje, które zostana również usunięte, jesteś pewien?'
            : 'Czy na pewno usunąć nagłówek?'
        requestDelete(message, () => handleDeleteHeader(header.headerId))
    }

    const requestDeleteItem = (itemId) => {
        requestDelete('Czy na pewno usunąć pozycję?', () => handleDeleteItem(itemId))
    }

    if (isLoading) {
        return <LoadingSpinner />
    }
    return (<>
        {confirmModal}
        <AddEditFooterItemModal
            show={itemModal.show}
            onHide={() => setItemModal({ show: false, editItem: null })}
            onSaved={refreshFooterElements}
            headers={footerHeaders}
            editItem={itemModal.editItem}
        />
        <AddEditFooterHeaderModal
            show={headerModal.show}
            onHide={() => setHeaderModal({ show: false, isRegistrationProfit: false, editItem: null })}
            onSaved={refreshFooterElements}
            isRegistrationProfit={headerModal.isRegistrationProfit}
            editItem={headerModal.editItem}
        />

        <h5 className='fw-semibold pb-2 mb-3'>Elementy paska nawigacji</h5>
        <div className='mb-5'>
            <h5 className='fw-semibold border-bottom pb-2 mb-1 primary-accent-color-text'>Stopka</h5>
            <p className='secondary-text mb-3'>Nagłówki stopki - kliknij wiersz, aby rozwinąć pozycje</p>
            <Table hover responsive className='mb-0' style={{ minWidth: '620px' }}>
                <thead>
                    <tr>
                        <th>Nagłówek</th>
                        <th className='text-center' style={{ width: '20%' }}>Liczba pozycji</th>
                        <th className='text-end' style={{ width: '15%' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {footerHeaders.length === 0 && (
                        <tr>
                            <td colSpan={3} className='text-center text-muted py-3'>Brak nagłówków stopki.</td>
                        </tr>
                    )}
                    {footerHeaders.map(header => (
                        <FooterHeaderRow
                            key={header.headerId}
                            header={header}
                            onEditHeader={handleEditHeader}
                            onEditItem={handleEditItem}
                            onDeleteHeader={requestDeleteHeader}
                            onDeleteItem={requestDeleteItem}
                        />
                    ))}
                </tbody>
            </Table>
            <div className='d-flex justify-content-end gap-2 mt-3'>
                <button className='btn-app-secondary' onClick={() => setItemModal({ show: true, editItem: null })}>Dodaj pozycję stopki</button>
                <button className='btn-app-primary' onClick={() => setHeaderModal({ show: true, isRegistrationProfit: false, editItem: null })}>Dodaj nagłówek pozycji stopki</button>
            </div>
        </div>

        <div className='mb-4'>
            <h5 className='fw-semibold border-bottom pb-2 mb-3 primary-accent-color-text'>Korzyści z rejestracji</h5>
            <Table hover responsive className='mb-0' style={{ minWidth: '360px' }}>
                <thead>
                    <tr>
                        <th>Tytuł</th>
                        <th className='text-end' style={{ width: '20%' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {registrationHeaders.length === 0 && (
                        <tr>
                            <td colSpan={2} className='text-center text-muted py-3'>Brak korzyści z rejestracji.</td>
                        </tr>
                    )}
                    {registrationHeaders.map(header => (
                        <tr key={header.headerId}>
                            <td className='align-middle'>{header.title}</td>
                            <td className='align-middle text-end'>
                                <div className='d-flex align-items-center justify-content-end flex-nowrap gap-2'>
                                    <FaRegEdit size={20} className='element-pointer' onClick={() => handleEditHeader(header)} title='Edytuj' />
                                    <Button size='sm' variant='outline-danger' onClick={() => requestDeleteHeader(header)} title='Usuń'>
                                        <FaTrash size={13} />
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div className='d-flex justify-content-end mt-3'>
                <button className='btn btn-app-primary' onClick={() => setHeaderModal({ show: true, isRegistrationProfit: true, editItem: null })}>Dodaj korzyść</button>
            </div>
        </div>
    </>)
}

const FooterHeaderRow = ({ header, onEditHeader, onEditItem, onDeleteHeader, onDeleteItem }) => {
    const [showItems, setShowItems] = useState(false)
    const items = header.footerItems ?? []

    return (<>
        <tr className='hoverable-row element-pointer' onClick={() => setShowItems(!showItems)}>
            <td className='align-middle fw-semibold'>{header.title}</td>
            <td className='align-middle text-center'>{items.length}</td>
            <td className='align-middle text-end'>
                <div className='d-flex align-items-center justify-content-end flex-nowrap gap-2'>
                    <FaRegEdit
                        size={20}
                        className='element-pointer'
                        onClick={(e) => { e.stopPropagation(); onEditHeader(header) }}
                        title='Edytuj'
                    />
                    <Button
                        size='sm'
                        variant='outline-danger'
                        onClick={(e) => { e.stopPropagation(); onDeleteHeader(header) }}
                        title='Usuń'
                    >
                        <FaTrash size={13} />
                    </Button>
                </div>
            </td>
        </tr>
        {showItems && (
            <tr>
                <td colSpan={3} className='p-0'>
                    <div className='table-items p-3'>
                        <Table bordered responsive className='mb-0 bg-white' style={{ minWidth: '640px' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '33%' }}>Tytuł</th>
                                    <th style={{ width: '32%' }}>URL</th>
                                    <th className='text-center' style={{ width: '20%' }}>Wewnątrz platformy E-Handel</th>
                                    <th className='text-end' style={{ width: '15%' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.length === 0 && (
                                    <tr>
                                        <td colSpan={4} className='text-center text-muted py-3'>Brak pozycji.</td>
                                    </tr>
                                )}
                                {items.map(item => (
                                    <tr key={item.itemId}>
                                        <td className='align-middle'>{item.title}</td>
                                        <td className='align-middle text-break'>{item.url}</td>
                                        <td className='align-middle text-center'>{item.isDirect ? 'Tak' : 'Nie'}</td>
                                        <td className='align-middle text-end'>
                                            <div className='d-flex align-items-center justify-content-end flex-nowrap gap-2'>
                                                <FaRegEdit size={20} className='element-pointer' onClick={() => onEditItem(item)} title='Edytuj' />
                                                <Button size='sm' variant='outline-danger' onClick={() => onDeleteItem(item.itemId)} title='Usuń'>
                                                    <FaTrash size={13} />
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </td>
            </tr>
        )}
    </>)
}

export default AdminPanelFooter
